import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Popover } from "@molecules"
import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

import { BottomSheetItemBase } from "@organisms/BottomSheet/BottomSheetItem/BottomSheetItem"
import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"
import { ViewTypeMenuComponentIds } from "@organisms/ViewMenu/ViewMenu.types"

import styles from "./TableViewMenu.module.scss"
import BottomSheetAddColumns from "./TableViewMenuBottomSheet/BottomSheetAddColumns/BottomSheetAddColumns"
import {
    BottomSheetSortingColumnsList,
    BottomSheetSortingOrderSelector,
} from "./TableViewMenuBottomSheet/BottomSheetSortingColumns/BottomSheetSortingColumns"
import TableViewMenuColumnsOrder from "./TableViewMenuColumnsOrder/TableViewMenuColumnsOrder"
import PopoverAddColumns from "./TableViewMenuPopover/PopoverAddColumns/PopoverAddColumns"
import PopoverOrderColumns from "./TableViewMenuPopover/PopoverOrderColumns/PopoverOrderColumns"
import PopoverSortingColumns from "./TableViewMenuPopover/PopoverSortingColumns/PopoverSortingColumns"
import TableViewMenuPopoverDivider from "./TableViewMenuPopover/TableViewMenuPopoverDivider/TableViewMenuPopoverDivider"

export const TABLE_VIEW_MENU_COMPONENT_IDS: ViewTypeMenuComponentIds = {
    desktop: ["main", "columns"],
    mobile: ["main", "columns", "add-columns", "sorting"],
}

export default function TableViewMenu() {
    const isDesktop = useIsDesktop()

    if (isDesktop) {
        return (
            <>
                <Popover.View componentId="main">
                    <Popover.Section animationType="slide">
                        <Popover.Body>
                            <Popover.SubHeader title="Sorting" />
                            <PopoverSortingColumns isVisible={true} />
                            <TableViewMenuPopoverDivider fullWidth={true} />
                            <Popover.SubHeader title="Columns" />
                            <PopoverOrderColumns isVisible={true} />
                        </Popover.Body>
                        <Popover.Footer.Root className={styles.footer}>
                            <ComponentNavigation.Navigate to="columns" direction="right" asChild={true}>
                                <Popover.Button
                                    icon={faIcon({ name: "plus", style: "regular" })}
                                    showChevron={true}
                                    isTabbable={true}
                                    onClick={() => {}}
                                >
                                    Add columns
                                </Popover.Button>
                            </ComponentNavigation.Navigate>
                        </Popover.Footer.Root>
                    </Popover.Section>
                </Popover.View>
                <Popover.View componentId="columns">
                    <Popover.Section animationType="fade">
                        <PopoverAddColumns isVisible={true} />
                    </Popover.Section>
                </Popover.View>
            </>
        )
    }

    return (
        <>
            <Popover.View componentId="main">
                <Popover.Section animationType="slide">
                    <Popover.Footer.Root className={styles.footer}>
                        <div className={styles.primaryContentItems}>
                            <ComponentNavigation.Navigate to="sorting" asChild={true} direction="left">
                                <BottomSheetItemBase
                                    icon={faIcon({ name: "arrow-up-arrow-down", style: "regular" })}
                                    isTabbable={true}
                                    label="Sorting"
                                    hasSubItems={true}
                                />
                            </ComponentNavigation.Navigate>
                            <ComponentNavigation.Navigate to="columns" asChild={true} direction="right">
                                <BottomSheetItemBase
                                    icon={faIcon({ name: "table-columns", style: "regular" })}
                                    isTabbable={true}
                                    label="Columns"
                                    hasSubItems={true}
                                />
                            </ComponentNavigation.Navigate>
                        </div>
                    </Popover.Footer.Root>
                </Popover.Section>
            </Popover.View>

            <Popover.View componentId="columns">
                <Popover.Section animationType="fade">
                    <PopoverHeader.Root>
                        <PopoverHeader.BackButton backDestination="main" aria-label="Back" />
                        <PopoverHeader.Title title="Columns" />
                    </PopoverHeader.Root>
                </Popover.Section>
                <Popover.Section animationType="slide">
                    <Popover.Body>
                        <TableViewMenuColumnsOrder isVisible={true} />
                    </Popover.Body>
                    <Popover.Footer.Root className={styles.footer}>
                        <ComponentNavigation.Navigate to="add-columns" asChild={true} direction="right">
                            <BottomSheetItemBase
                                icon={faIcon({ name: "plus", style: "regular" })}
                                isTabbable={true}
                                onClick={() => {}}
                                hasSubItems={true}
                                label="Add Columns"
                            />
                        </ComponentNavigation.Navigate>
                    </Popover.Footer.Root>
                </Popover.Section>
            </Popover.View>

            <Popover.View componentId="add-columns">
                <BottomSheetAddColumns isVisible={true} />
            </Popover.View>

            <Popover.View componentId="sorting">
                <Popover.Section animationType="fade">
                    <PopoverHeader.Root>
                        <PopoverHeader.BackButton backDestination="main" aria-label="Back" />
                        <PopoverHeader.Title title="Sorting" />
                    </PopoverHeader.Root>
                </Popover.Section>
                <Popover.Section animationType="slide">
                    <Popover.Body>
                        <BottomSheetSortingColumnsList isVisible={true} />
                    </Popover.Body>
                    <Popover.Footer.Root className={styles.footerPadded}>
                        <BottomSheetSortingOrderSelector isVisible={true} />
                    </Popover.Footer.Root>
                </Popover.Section>
            </Popover.View>
        </>
    )
}
